// feature-flags.ts

export const FEATURE_FLAGS = {
	BETA: 'beta',
	OPTIMIZED_AVAILABLE_FORMS: 'optimizedAvailableForms',
} as const;
